import { normalizeMessage } from "../utils/chat";
import EventMessageCard from "./EventMessageCard";

// Shared message-list rendering for Buddies.js's embedded chat panel and
// ChatPage.js: chronological order, outgoing messages right-aligned/
// visually distinct, incoming left-aligned, event messages rendered via the
// existing EventMessageCard (unchanged).
function ChatMessageList({ messages, currentUid, containerRef, bottomRef, emptyLabel, className = "" }) {
  return (
    <div ref={containerRef} className={className}>
      {messages.length === 0 ? (
        <p className="py-10 text-center text-gray-400">{emptyLabel}</p>
      ) : (
        <div className="flex flex-col gap-3">
          {messages.map((raw, index) => {
            const msg = normalizeMessage(raw);
            const isOwn = msg.senderId === currentUid;
            return (
              <div key={index} className={`flex ${isOwn ? "justify-end" : "justify-start"}`}>
                {msg.type === "event" ? (
                  <EventMessageCard eventId={msg.eventId} />
                ) : (
                  <div
                    className={`max-w-[80%] sm:max-w-xs rounded-lg p-3 text-sm font-medium break-words ${
                      isOwn
                        ? "bg-blue-600 text-white text-right shadow-md"
                        : "bg-slate-700 text-gray-200 text-left shadow-md"
                    }`}
                  >
                    {msg.text}
                  </div>
                )}
              </div>
            );
          })}
          <div ref={bottomRef} />
        </div>
      )}
    </div>
  );
}

export default ChatMessageList;
